export default "__VITE_ASSET__BOgTogR1__"